import User from "./User";
import AppointmentType from "./AppointmentType";
import AppointmentTypeService from "./services/AppointmentTypeService";
import PersistentData from "./PersistentData";
import SettingsData from "./SettingsData";
import moment from 'moment';
import { SettingsHours } from "./SettingsHours";
import AccountService from "./services/AccountService";
import ClinicService from "./services/ClinicService";

export default class Clinic extends PersistentData{
    constructor(clinicId){
        super(ClinicService.GetCachePath(clinicId));
        this.id = clinicId;
        this.appTypesPath = 'AppointmentTypes/';
        this.appTypes = AppointmentTypeService.GetTypeCache(clinicId); // new PersistentData(this.pathId + '/' + clinicId + '/AppointmentTypes');
        this.doctors = new DoctorHelper(this.dataPath + '/Doctor');// new PersistentData(this.dataPath + '/' + clinicId + '/Doctor');
        this.settings = new ClinicSettings(this.dataPath);
        //console.log("Doctors Path:", this.doctors.storageId);
    }

    getAppType(appId){
        return AppointmentType.GetById(appId);// this.appTypes.getData(appId);
    }

    getDoctor(doctorId){
        let d = this.doctors.getData(doctorId);
        //console.log("Getting Doctor: " + doctorId, d)
        return new User(d);
    }

}

export class ClinicSettings{
    constructor(dataPath){
        this.hours = new SettingsHours(dataPath);
    }
    loadSettings(){
        return this.hours.serverDefaults('ClinicSchedules').then(() => {
            return this.hours.serverExceptions('ClinicScheduleExceptions')
        })
    }
}

class DoctorHelper extends PersistentData{
    getAll(){
        return super.getAll().filter(dr => dr.status === 'active');
    }
}


// WEBPACK FOOTER //
// ./src/api/Clinic.js